jQuery(document).ready(function($){

  /** Single product page audio JS **/
  // $('.single_product slider-component').mouseenter(function(){
  //   $(this).addClass('hovered');
  //   $(this).find('.custom_player_btns').fadeIn();
  // });

  // $('.single_product slider-component').mouseleave(function(){
  //   $(this).removeClass('hovered');
  //   $(this).find('.custom_player_btns').fadeOut();
  // });

  //   $('.custom_player_btns #play_btn').click(function(){
  //   $('.product_audio_player #product_audio')[0].play();
  //   $('.custom_player_btns #play_btn').addClass('d-none');
  //   $('.custom_player_btns #pause_btn').removeClass('d-none');
  // });

  // $('.custom_player_btns #pause_btn').click(function(){
  //   $('.product_audio_player #product_audio')[0].pause();
  //   $('.custom_player_btns #play_btn').removeClass('d-none');
  //   $('.custom_player_btns #pause_btn').addClass('d-none');
  // });


  $('.card--card.card--media > .featured_item').click(function(){
    let audio_url = $(this).data('file');
    let image_url = $(this).data('image');

    console.log(audio_url);
    console.log(image_url);

    $('.off_pro_img').html("<img src='"+image_url+"'>");
    $('.card_product_audio').html("<source src='"+audio_url+"'>");
    
  });
  

  // const audio = document.querySelector('.product_audio_player #product_audio');
  // audio.addEventListener('ended', (event) => {
  //     $('.custom_player_btns #play_btn').removeClass('d-none');
  //     $('.custom_player_btns #pause_btn').addClass('d-none');
  // });

  
  
});